import { Icon } from "components/shared/icon/Icon";
import { useInteractivityListeners } from "hooks/useInteractivityListeners";
import { useParticipantsInAreaFilter } from "hooks/useParticipantsInAreaFilter";
import React, { useState } from "react";
import { RemoteParticipantData } from "store/remote-participants/types";
import { Room } from "twilio-video";
import { RemoteParticipant } from "../remote-participant/RemoteParticipant";
import { ParticipantInfo } from "./ParticipantInfo";
import { isMobile } from "react-device-detect";
import styles from "./ParticipantsList.module.css";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/reducers";

interface ParticipantsListProps {
  room?: Room;
  participants: RemoteParticipantData[];
  participantsInArea: string[];
}

export const ParticipantsList: React.FC<ParticipantsListProps> = ({
  room,
  participants,
  participantsInArea,
}) => {
  const { participantsInAreaFilter } = useParticipantsInAreaFilter(
    participantsInArea
  );

  const [show, setShow] = useState<boolean>(false);
  const { showChat } = useSelector(
    (s: RootState) => s.chatMessages
  );
  useInteractivityListeners(styles["list"]);

  return (
    <div
      className={`${styles["participants-list-container"]} ${
        isMobile ? styles["participants-list-container-portrait"] : ""
      }  ${show ? styles["show"] : ""} ${showChat ? styles["hide"] : ""}`}
    >
      <div className={styles["actions"]}>
        <button onClick={() => setShow((prev) => !prev)}>
          <Icon id="users" className={styles["users-icon"]}></Icon>
          <span className={styles["badge"]}>{participants.length}</span>
        </button>
      </div>
      <div className={`${styles["list"]} ${show ? styles["show"] : ""}`}>
        <p className="mb-0">Guests</p>
        <hr className={styles["hr"]}></hr>
        {participants
          .filter(participantsInAreaFilter)
          .sort((a) => {
            return a.videoIsEnabled && !a.isSwitchedOff ? -1 : 1;
          })
          .map((p) => {
            const participant = room?.participants.get(p.sid);
            if (participant) {
              if (p.videoIsEnabled && !p.isSwitchedOff) {
                // The participant has a RemoteParticipant component rendered
                // elsewhere in the grid, so use this "text-only" component.
                return (
                  <ParticipantInfo
                    key={participant.sid + "-participant-info"}
                    participantData={p}
                    isDominantSpeaker={
                      room?.dominantSpeaker?.sid === participant.sid
                    }
                  />
                );
              }

              return (
                <RemoteParticipant
                  key={participant.sid + "-remote-tracks"}
                  participant={participant}
                  participantState={p}
                  inSidebar={true}
                  audioOnly={true}
                  isDominantSpeaker={
                    room?.dominantSpeaker?.sid === participant.sid
                  }
                />
              );
            }

            return null;
          })}
      </div>
    </div>
  );
};
